<!--配色管理-配色列表-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm"></ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <a-button type="primary" :loading="loading" v-hasPermi="['mdm:colorList:import']" @click="handleImport">导入</a-button>
        <a-button type="primary" :loading="loading" v-hasPermi="['mdm:colorList:export']" @click="handleExport">导出</a-button>
        <import-excel ref="importExcelRef" :downloadParams="downloadParams" :uploadParams="upload" @refresh="() => handleOk(false)" />
        <download-modal :apiFun="apiMaterialMatchColorRelationExport" ref="download" />
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1600 }">
          <!-- 配色码 -->
          <template slot="matchColorCode" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.matchColorCode }}</span>
            <a-input v-else v-model="record.matchColorCode" :maxLength="50" />
          </template>
          <!-- 质检员 -->
          <template slot="qcInspector" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.qcInspector }}</span>
            <a-input v-else v-model="record.qcInspector" :maxLength="50" />
          </template>
          <div slot="operation" slot-scope="{ text, record }" class="operation-btn">
            <a v-if="!isEdit || currentId !== record.id" v-hasPermi="['mdm:colorList:edit']" @click="handleEdit(record)">编辑</a>
            <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
            <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
            <a class="ml10" @click="handleLog(record)">日志</a>
          </div>
        </ls-api-table>
      </div>
      <operation-log-model ref="operationLogModelRef" :logLoading="logLoading" :logList="logList" @closeLog="closeLogFun" />
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import cloneDeep from 'lodash.clonedeep'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import ImportExcel from "@/components/ImportExcel/importExcel"
import OperationLogModel from '@/components/operation-log/operation-log-model.vue'
import moment from 'moment'
import {
  apiMaterialMatchColorRelationEdit,
  apiMaterialMatchColorRelationExport,
  apiMaterialMatchColorRelationList, apiRefreshMaterialColorRelation
} from '@/api/color-management/color-list/colorListApi'
import { apiGetLog } from '@/api/mes/productionPrepare/teamManage'

export default {
  name: 'ColorList',
  components: { DownloadModal, ImportExcel, OperationLogModel },
  data() {
    return {
      apiMaterialMatchColorRelationExport,
      logLoading: false, // 日志loading
      logList: [], // 日志列表
      isEdit: false,
      currentId: "",
      loading: false,
      // 用户导入参数
      upload: {
        url: process.env.VUE_APP_API_BASE_URL + '/mdm/materialMatchColorRelation/import' // 上传的地址
      },
      // 导入模板下载参数
      downloadParams: {
        method: 'post',
        url: 'mdm/materialMatchColorRelation/template',
        name: `配色列表导入模板_${moment().format('YYYY-MM-DD')}.xlsx`
      },
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiMaterialMatchColorRelationList, false),
        pageCurrent: true
      },
      // 查询参数
      queryParams: {
        primaryItemCode: undefined,
        primaryBatchNo: undefined,
        primaryRkDate: undefined,
        primaryRkDateStart: undefined,
        primaryRkDateEnd: undefined,
        secondaryItemCode: undefined,
        secondaryBatchNo: undefined,
        secondaryRkDate: undefined,
        secondaryRkDateStart: undefined,
        secondaryRkDateEnd: undefined,
        matchColorCode: undefined,
        qcInspector: undefined,
        matchColorDate: undefined,
        matchColorDateStart: undefined,
        matchColorDateEnd: undefined
      },
      formList: [
        { label: '材料编码1(主)', decorator: ['primaryItemCode'], type: 'input' },
        { label: '批次号(主)', decorator: ['primaryBatchNo'], type: 'input' },
        {
          label: '入库日期(主)',
          type: 'range',
          decorator: ['primaryRkDate'],
          disposeFormat: {
            primaryRkDateStart: (change) => { return change[0].format('yyyy-MM-DD 00:00:00') },
            primaryRkDateEnd: (change) => { return change[1].format('yyyy-MM-DD 23:59:59') }
          }
        },
        { label: '材料编码2(辅)', decorator: ['secondaryItemCode'], type: 'input' },
        { label: '批次号(辅)', decorator: ['secondaryBatchNo'], type: 'input' },
        {
          label: '入库日期(辅)',
          type: 'range',
          decorator: ['secondaryRkDate'],
          disposeFormat: {
            secondaryRkDateStart: (change) => { return change[0].format('yyyy-MM-DD 00:00:00') },
            secondaryRkDateEnd: (change) => { return change[1].format('yyyy-MM-DD 23:59:59') }
          }
        },
        { label: '配色码', decorator: ['matchColorCode'], type: 'input' },
        {
          label: '配色日期',
          type: 'range',
          decorator: ['matchColorDate'],
          disposeFormat: {
            matchColorDateStart: (change) => { return change[0].format('yyyy-MM-DD 00:00:00') },
            matchColorDateEnd: (change) => { return change[1].format('yyyy-MM-DD 23:59:59') }
          }
        },
        { label: '质检员', decorator: ['qcInspector'], type: 'input' }
      ],
      // 表格字段
      columns: [
        { title: '材料编码1(主)', dataIndex: 'primaryItemCode', align: 'center', width: 120 },
        { title: '材料名称1(主)', dataIndex: 'primaryItemName', align: 'center', width: 180 },
        { title: '材料编码2(辅)', dataIndex: 'secondaryItemCode', align: 'center', width: 120 },
        { title: '材料名称2(辅)', dataIndex: 'secondaryItemName', align: 'center', width: 180 },
        { title: '批次号(主)', dataIndex: 'primaryBatchNo', align: 'center', width: 120 },
        { title: '批次号(辅)', dataIndex: 'secondaryBatchNo', align: 'center', width: 120 },
        { title: '可用库存(主)', dataIndex: 'primaryQty', align: 'center', width: 100 },
        { title: '可用库存(辅)', dataIndex: 'secondaryQty', align: 'center', width: 100 },
        { title: '入库日期(主)', dataIndex: 'primaryRkDate', align: 'center', width: 110 },
        { title: '入库日期(辅)', dataIndex: 'secondaryRkDate', align: 'center', width: 110 },
        { title: '配色日期', dataIndex: 'matchColorDate', align: 'center', width: 140 },
        { title: '配色码', dataIndex: 'matchColorCode', align: 'center', scopedSlots: { customRender: 'matchColorCode' }, width: 90, stickyFixed: 'right' },
        { title: '质检员', dataIndex: 'qcInspector', align: 'center', scopedSlots: { customRender: 'qcInspector' }, width: 90, stickyFixed: 'right' },
        {
          title: '操作',
          width: 130,
          align: 'center',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ]
    }
  },
  mounted() {
    this.loading = false;
    this.onSearch()
  },
  methods: {
    // 导入弹窗
    handleImport() {
      this.$refs.importExcelRef.show()
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 关闭日志弹窗
    closeLogFun() {
      this.logLoading = false;
      this.logList = [];
    },
    // 操作日志弹窗
    handleLog(row) {
      this.logList = []
      this.logLoading = true
      this.$refs.operationLogModelRef.show()
      apiGetLog({ id: row.id, type: 9 }).then(res => {
        if (res?.code === 200) {
          if (res?.data?.length > 0) { this.logList = res.data }
        }
      }).finally(() => {
        this.logLoading = false
      })
    },
    // 编辑-保存
    handleSave (record) {
      apiMaterialMatchColorRelationEdit(record).then(res => {
        if (res?.code === 200) {
          this.$message.success('保存成功')
          this.handleOk(true)
        } else {
          this.$message.error(res?.msg || '保存失败')
        }
      })
    },
    // 刷新
    onRefresh() {
      this.loading = true;
      apiRefreshMaterialColorRelation().then(res => {
        if (res?.code === 200) {
          this.$message.success('刷新成功')
          this.handleOk(true)
        } else {
          this.$message.error(res?.msg || '刷新失败')
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 新增/修改框事件, changePage为true，则不返回到第一页
    handleOk(changePage = false) {
      this.onSearch({ ...this.$refs.refSearchForm.getSearchValue() }, changePage)
    },
    // 表单搜索
    onSearch(value = {}, changePage = false) {
      this.isEdit = false;
      this.currentId = '';
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData(changePage)
    },
    // 取消
    handleCancel () {
      this.handleOk(true)
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        primaryItemCode: undefined,
        primaryBatchNo: undefined,
        primaryRkDate: undefined,
        primaryRkDateStart: undefined,
        primaryRkDateEnd: undefined,
        secondaryItemCode: undefined,
        secondaryBatchNo: undefined,
        secondaryRkDate: undefined,
        secondaryRkDateStart: undefined,
        secondaryRkDateEnd: undefined,
        matchColorCode: undefined,
        qcInspector: undefined,
        matchColorDate: undefined,
        matchColorDateStart: undefined,
        matchColorDateEnd: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    }
  }
}
</script>

<style scoped lang="less">
.operation-btn{
  display: flex;
  justify-content: center;
  .ant-btn{
    padding: 0 4px;
  }
  .ant-btn-link:focus, .ant-btn-link:hover {
    border-color: transparent !important;
  }
}
</style>
